<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[700px]">
    <div class="px-4 py-4 text-center tracking-normal tablet:px-6 desktop:px-10">

      <strong class="text-2xl uppercase">{{ $t('Nejdříve vyberte parametr', dialog?.data.parameters.length) }}: <span class="text-secondary-500">{{ dialog?.data.parameters.join(` ${i18n.t('a')} `) }}</span></strong>

    </div>
  </AtomsGlobalDialog>
</template>
<script setup>

const i18n = useI18n();

const close = () => useDialog().close();

const dialog = computed(() => useDialog().get('selectParameters'));

</script>